import { ReactComponent as Clapping } from 'assets/images/videoReactions/clapping.svg';
import styled from 'styled-components/macro';

const ClappingIcon = styled(Clapping)`
  width: ${props => props.width || '24px'};
  height: ${props => props.height || '24px'};
`;

export default ClappingIcon;
